<template>
    <div class="news-home">
        <!-- <HeaderTop></HeaderTop> -->
        <!-- <Header :page="0"></Header> -->
        <!-- 通知公告 -->
        <div class="content">
          <div class="content-box">
            <div class="box-left">
              <div class="notice flex-align-between">
                <div class="title flex-align-center">
                  <img src="../../assets/home/sound.png" alt="">
                  <div class="sound">通知公告</div>
                </div>
                <span class="more pointer" @click="gotoPage('/list/course',1)">更多 &gt;</span>
              </div>
              <div class="notice-box flex-between">
                <div class="left">
                  <el-carousel height="323px" indicator-position="outside">
                    <el-carousel-item v-for="(item,index) in noticeList" :key="index" @click.native="getoDetail('/list/course/detail/',item)">
                      <img :src="item.cover" :title="item.title" alt="" />
                      <div class="titleposition pointer"><p :title="item.title">{{item.title}}</p></div>
                    </el-carousel-item>
                  </el-carousel>
                </div>
                <div class="right">
                  <div class="flex-align-between pointer container" v-for=" (item,index) in noticesList" :key="index" @click="getoDetail('/list/course/detail/',item)">
                    <div class="container-left flex-align">
                      <span></span>
                      <div :title="item.title" class="container-title">
                        {{item.title}}
                        </div>
                    </div>
                    <div v-if="item && item.createTime" class="container-right flex-align-center">{{handleTimeFive(item.createTime||0)}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="box-right">
              <div class="download pointer" v-for="(item,index) in iconlist" :key="index" @click="open(item)">
                <div class="download-item ">
                  <div class="item-box flex-layout">
                    <img :src="item.icon" alt="">
                    <div class="name">
                      <div class="title">{{item.name}}</div>
                      <p class="font"> {{item.title}} </p>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
          <!-- CCPT -->
          <div class="painting">
            <div class="painting-box">
               <el-carousel :interval="5000" arrow="always" height="183px">
                  <el-carousel-item v-for="(item,index) in CCPTList" :key="index" @click.native="getoDetail('/detail/',item)">
                    <div class="board flex-align-around">
                      <img :src="item.cover" alt="">
                     
                    </div>

                  </el-carousel-item>
                </el-carousel>
              <!-- <div class="ccpt">教育部书画等级考试CCPT</div>
              <div class="banner">是教育部考试中心主办、面向全国书画学习者的技能培训与测评系统。举办教育部书画等级考试的目的在于学习和继承中华优秀……</div>
              <div class="more">了解更多&gt;</div> -->
            </div>
          </div>
          
          

          <div class="new flex-between">
            

            <div class="menu">
                <div class="new-title flex-align-between pointer">
                  <div class="new-box flex-align">
                    <img style="width: 30px;height: 27px;" src="../../assets/home/icon/icon6.png" alt="">
                    <span class="work">考试教材</span>
                  </div>
                  <span class="more pointer" @click="$router.push('/list/teaching')">更多 &gt;</span>
                </div>
                <div class="message pointer" > <!--  @click="getdetails(articleId,type)" -->
                <div class="date">
                  <img src="../../assets/home/base/base2.png" alt="">
                </div>
                  <div class="table" @click="getoDetail('/list/teaching/detail/',TeachingArticle)">
                    <p v-if="TeachingArticle&&TeachingArticle.createTime" class="table-pa"><span>{{handleTimeFive(TeachingArticle.createTime||0)}}</span>{{TeachingArticle.title}}</p>    <!-- title -->
                    <p class="table-pas">{{TeachingArticle.introduction}}</p> <!-- introduction -->
                    
                  </div>
                </div>
                <div class="text pointer">
                  <!-- <div class="paragraph"> -->
                  <div class="paragraph"  v-for="(item,index) in TeachingList"  :key="index" @click="geDetail('/list/teaching/detail/',item)">
                    <p :title="item.title" class="date-par">{{item.title}}</p>
                    <p v-if="item&&item.createTime" class="date-days">{{handleTimeOne(item.createTime ||0)}}</p><!-- {{shijiantime1(createTime)}} -->
                  </div>
              </div>
            </div>
            <div class="menu">
                <div class="new-title flex-align-between pointer">
                  <div class="new-box flex-align">
                    <img style="width: 27px;height: 27px;" src="../../assets/home/icon/icon5.png" alt="">
                    <span class="work">考试大纲</span>
                  </div>
                  <span class="more pointer" @click="$router.push('/list/learning')">更多 &gt;</span>
                </div>
                <div class="message pointer" > <!--  @click="getdetails(articleId,type)" -->
                <div class="date">
                  <img src="../../assets/home/base/base1.png" alt="">
                </div>
                  <div class="table"  @click="getoDetail('/list/learning/detail/',OutlineArticle)">
                    <p v-if="OutlineArticle &&OutlineArticle.createTime" class="table-pa"><span>{{handleTimeFive(OutlineArticle.createTime||0)}}</span>{{OutlineArticle.title}}</p>    <!-- title -->
                    <p class="table-pas">{{OutlineArticle.introduction}}</p> <!-- introduction -->
                    
                  </div>
                </div>
                <div class="text pointer">
                  <div class="paragraph"  v-for="(item,index) in OutlineList"  :key="index" @click="getoDetail('/list/learning/detail/',item)">
                    <p :title="item.title" class="date-par">{{item.title}}</p>
                    <p v-if="item&&item.createTime" class="date-days">{{handleTimeOne(item.createTime||0)}}</p><!-- {{shijiantime1(createTime)}} -->
                  </div>
              </div>
            </div>
          </div>

          <!-- <div class="new border flex-between">
            <div class="menu">
                <div class="new-title flex-align-between pointer ">
                  <div class="new-box flex-align">
                    <img style="width: 28px;height: 27px;" src="../../assets/home/icon/icon7.png" alt="">
                    <span class="work">历年试卷</span>
                  </div>
                  <span class="more pointer" @click="$router.push('/list/testing')">更多 &gt;</span>
                </div>
                <div class="message pointer" >
                 <div class="date">
                  <img src="../../assets/home/base/base3.png" alt="">
                </div>
                  <div class="table"  @click="getoDetail('/list/testing/detail/',TestArticle)">
                    <p v-if="TestArticle&&TestArticle.createTime" class="table-pa"><span>{{handleTimeFive(TestArticle.createTime||0)}}</span>{{TestArticle.title}}</p> 
                    <p class="table-pas">{{TestArticle.introduction}}</p> 
                    
                  </div>
                </div>
                <div class="text pointer">
                 
                  <div class="paragraph"  v-for="(item,index) in TestList"  :key="index"  @click="getoDetail('/list/testing/detail/',item)">
                    <p class="date-par">{{item.title}}</p>
                    <p v-if="item&&item.createTime" class="date-days">{{handleTimeOne(item.createTime||0)}}</p>
                  </div>
              </div>
            </div>

            <div class="menu">
                <div class="new-title flex-align-between pointer ">
                  <div class="new-box flex-align">
                    <img style="width: 28px;height: 27px;" src="../../assets/home/icon/icon8.png" alt="">
                    <span class="work">师资培训</span>
                  </div>
                  <span class="more pointer" @click="$router.push('/list/training')">更多 &gt;</span>
                </div>
                <div class="message pointer" >
                 <div class="date">
                  <img src="../../assets/home/base/base4.png" alt="">
                </div>
                  <div class="table" @click="getoDetail('/list/training/detail/',TrainArticle)">
                    <p v-if="TrainArticle&&TrainArticle.createTime" class="table-pa"><span>{{handleTimeFive(TrainArticle.createTime||0)}}</span>{{TrainArticle.title}}</p>
                    <p class="table-pas">{{TrainArticle.introduction}}</p> 
                    
                  </div>
                </div>
                <div class="text pointer">
                 
                  <div class="paragraph"  v-for="(item,index) in TrainList"  :key="index" @click="getoDetail('/list/training/detail/',item)">
                    <p class="date-par">{{item.title}}</p>
                    <p v-if="item&&item.createTime" class="date-days">{{handleTimeOne(item.createTime||0)}}</p>
                  </div>
              </div>
            </div>
          </div> -->
          <!-- 组考单位 -->
          <div class="team">
             <div class="notice flex-align-between">
                <div class="title flex-align-center">
                  <img style="width: 28px;height: 28px;" src="../../assets/home/icon/icon9.png" alt="">
                  <div class="sound">专家团队</div>
                </div>
                <span class="more pointer" @click="$router.push('/list/teamlist')">更多 &gt;</span>
              </div>
              <div class="team-list">
                <el-carousel :interval="5000" arrow="always" height="280px" :autoplay="false" @change="change($event)">
                  <el-carousel-item v-for="(item,index) in expertteam" :key="index">
                    <div class="board flex-align-wrap">
                      <div class="board-item" v-for="(items,ines) in item" :key="ines">
                        <team-view :items="items"></team-view>
                      </div>
                    </div>

                  </el-carousel-item>
                </el-carousel>
              </div>
          </div>
          <!-- 组考单位 -->
          <div class="company">
             <div class="notice flex-align-between">
                <div class="title flex-align-center">
                  <img src="../../assets/home/company.png" alt="">
                  <div class="sound">组考单位</div>
                </div>
                <span class="more pointer" @click="gotoPage('/list/information',2)">更多 &gt;</span>
              </div>
              <div class="company-list">
                <!-- <div class="board-item" v-for="(item,index) in CompanyList " :key="index">
                  <img :src="item.cover" alt="">
                  <div class="name">{{item.title}}</div>
                </div> -->
                 <el-carousel :interval="5000" arrow="always" height="260px" :autoplay="true">
                  <el-carousel-item v-for="(item,index) in CompanyList" :key="index" >
                    <div class="board">
                      <div class="board-item " v-for="(items,ines) in item" :key="ines" @click="getoDetail('/list/information/detail/',items)">
                        <div class="img">
                          <img :src="items.cover" alt="">
                        </div>
                        <div class="name">{{items.title}}</div>
                      </div>
                    </div>

                  </el-carousel-item>
                </el-carousel>
              </div>
          </div>
          <!-- 考生服务 -->
          <div class="service">
            <div class="service-box paddings">
              <div class="notice flex-align-between">
                  <div class="title flex-align-center">
                    <img style="width: 25px;height: 29px;" src="../../assets/home/icon/icon10.png" alt="">
                    <div class="sound">考生服务</div>
                  </div>
                  <!-- <span class="more pointer">更多 &gt;</span> -->
                </div>
                <div class="company-list flex-align-between">
                  <div class="board-item pointer" v-for="(item,index) in servicelist " :key="index"  @click="getoserveDetail('/list/service/detail/',item)">
                    <img :src="item.icon" alt="">
                    <div class="name">{{item.name}}</div>
                  </div>
                </div>
            </div>
            <div class="service-box padding">
             <div class="notice flex-align-between">
                  <div class="title flex-align-center">
                    <img style="width: 28px;height: 28px;" src="../../assets/home/icon/icon11.png" alt="">
                    <div class="sound">友情链接</div>
                  </div>
                  <!-- <span class="more pointer">更多 &gt;</span> -->
                </div>
                <div class="friendship-box flex-align-wrap">
                  <div class="friendship pointer" v-for="(item,index) in Linkslist" :key="index" @click="gotoUrl(item)">
                    <div class="name">{{item.name}}</div>
                  </div>
                </div>
            </div>
          </div>
        </div>
        <footer-view></footer-view>
        <!-- <scorllTop></scorllTop> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
          flag:false,
          expertteam:[],
          noticeList:[],
          noticesList:[],
          CompanyList:[],
          OutlineList:[],
          CCPTList:[],
          OutlineArticle:{},
          TeachingArticle:{},
            TeachingList:[],
           TestArticle:{},
            TestList:[],
            TrainArticle:{},
            TrainList:[],
            iconlist:[{
              name:'线上报名',
              title:'Online registration',
              icon:require(`../../assets/home/icon/icon1.png`),
              url:'https://member.neea.cn/login/new?returnUrl=http%3A%2F%2Forder.neea.cn%2FfirstFlowNode%2F15'
            },{
              name:'准考证查询',
              title:'Admission ticket inquiry',
              icon:require(`../../assets/home/icon/icon2.png`),
              url:'https://member.neea.cn/login/new?returnUrl=http%3A%2F%2Forder.neea.cn%2Forder%2FmySignUp'
            },{
              name:'成绩查询',
              title:'Results the query',
              icon:require(`../../assets/home/icon/icon3.png`),
              url:'http://cjcx.neea.edu.cn/html1/folder/1508/206-1.htm?sid=2S3kiOgdNeIUawVwBUTCA8'
            },{
              name:'领取证书',
              title:'Certificate of certificates',
              icon:require(`../../assets/home/icon/icon4.png`),
              url:'http://zscx.neea.edu.cn'
            }],
            servicelist:[{
              name:'考生须知',
              icon:require(`../../assets/home/icon/icon12.png`),
              clazz:10,

              },{
              name:'考试时间',
              icon:require(`../../assets/home/icon/icon13.png`),
              clazz:11,
              },{
              name:'报名流程',
              icon:require(`../../assets/home/icon/icon14.png`),
              clazz:12,
              },
            ],
            Linkslist:[{
              name:'教育部考试中心',
              url:'http://www.neea.edu.cn'
            },{
              name:'书画等级考试CCPT',
              url:'http://ccpt.neea.edu.cn'
            },{
              name:'首都师范大学',
              url:'https://www.cnu.edu.cn'
            },{
              name:'首师优字汉字识写平台',
              url:'http://www.cnuzi.com'
            },{
              name:'双优云桥智慧研修平台',
              url:'https://yun.cnuen.net/login'
            },{
              name:' 书画等级考试河南省考试办公室',
              url:' http://www.hnccpt.cn/'
            },{
              name:'广东省教育考试服务中心',
              url:'https://www.eesc.com.cn/#/index'
            },],
            newsType:true,
            isNav:true,
            currentPage:0,
            workTotalList:[],
            workArticle:{},
            workList:[],
        }
    },
    computed:{
    },
    methods: { 
      change(val) {
        console.log(val)
      },
      open(item) {
        var param=setTimeout(()=>{
          window.open(item.url);
        }, 3000);
          this.$confirm('3秒之后将自动跳转至教育考试中心官网, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$message({
            //   type: 'success',
            //   message: '删除成功!'
            // });
            if(item.hasOwnProperty('url')) {
              // setTimeout(()=>{
                window.open(item.url);
              // }, 3000)
            } 
          }).catch(() => {
            clearTimeout(param);
            this.$message({
              type: 'info',
              message: '已取消跳转'
            });          
          });
        },
        gotoPage(path,index) {
          // sessionStorage.setItem('isActive', index) 
          this.$router.push(path)
        },
        // 专家团队
        
        async getTeaList(){
          let params = {
                // clazz:4,
                // pageNum:1,
                // pageSize:6,
            }
          let resData = await Api.Home.getTeaList(params);
          if(resData.rows.length>0) {
            this.expertteam = this.groupingArray(resData.rows,5)
          }
        },
        // 按数量分组数组
        groupingArray(data, num) {
          let result = [];
          for(var i=0;i<data.length;i+=num){
            result.push(data.slice(i,i+num));
          }
          return result;
        },
      isBigEnough(element, index, array) {
          return (index <= 4);
      },
      async getNewsNoticeList(){
        //type  通知公告4  考试大纲5  考试教材6  历年试卷7   师资培训8  组考单位9
        //考生须知  10
        //考试时间 11 
        //报名流程 12 
        //教育部书画等级考试 13
        //关于我们  14
        //一分钟了解如何申请组考单位  15
        let params = {
                clazz:4,
                pageNum:1,
                pageSize:11,
                // isAsc:'desc',
            }
            let resData = await Api.Home.getNewsList(params);
            this.noticeList = resData.rows.filter((item,index) => index<5);
            this.noticesList = resData.rows.filter((item,index) => index>=5);


        },

        async getNewsCompanyList(){
        //type :通知公告4  考试大纲5  考试教材6  历年试卷7   师资培训8  组考单位9
        let params = {
                clazz:9,
                pageNum:1,
                pageSize:null,
            }
            let resData = await Api.Home.getNewsList(params);
            // this.CompanyList = resData.rows;
            let newArr = resData.rows.splice(0,12)
            console.log("newArr",newArr)
            if(resData.rows.length>0) {this.CompanyList = this.groupingArray(newArr,4)}
            

        },

        async getNewsOutlineList(){
        //type :通知公告4  考试大纲5  考试教材6  历年试卷7   师资培训8  组考单位9
        let params = {
                clazz:5,
                pageNum:1,
                pageSize:7,
            }
            let resData = await Api.Home.getNewsList(params);
            this.OutlineArticle = resData.rows[0];
            this.OutlineList = resData.rows.filter((item,index) => index>=1);

        },

        async getNewsTeachingList(){
        //type :通知公告4  考试大纲5  考试教材6  历年试卷7   师资培训8  组考单位9
        let params = {
                clazz:6,
                pageNum:1,
                pageSize:7,
            }
            let resData = await Api.Home.getNewsList(params);
            this.TeachingArticle = resData.rows[0];
            this.TeachingList = resData.rows.filter((item,index) => index>=1);

        },

         async getNewsTestList(){
        //type :通知公告4  考试大纲5  考试教材6  历年试卷7   师资培训8  组考单位9
        let params = {
                clazz:7,
                pageNum:1,
                pageSize:7,
            }
            let resData = await Api.Home.getNewsList(params);
            this.TestArticle = resData.rows[0];
            this.TestList = resData.rows.filter((item,index) => index>=1);

        },

        async getNewsTrainList(){
        //type :通知公告4  考试大纲5  考试教材6  历年试卷7   师资培训8  组考单位9
        let params = {
                clazz:8,
                pageNum:1,
                pageSize:7,
            }
            let resData = await Api.Home.getNewsList(params);
            this.TrainArticle = resData.rows[0];
            this.TrainList = resData.rows.filter((item,index) => index>=1);

        },
        async getCCPTList(){
        //type :通知公告4  考试大纲5  考试教材6  历年试卷7   师资培训8  组考单位9
        let params = {
                clazz:13,
                pageNum:1,
                pageSize:2,
            }
            let resData = await Api.Home.getNewsList(params);
            this.CCPTList = resData.rows;

        },
        async getoserveDetail(path,item) {
            if(item.hasOwnProperty('url')) {
                window.open(item.url);
            } else {
                let msg = {name:item.name}
                this.$router.push(path+item.clazz ,msg)
            }
        },
       
        async getoDetail(path,item) {
            if(item.hasOwnProperty('url')) {
                window.open(item.url);
            } else {
                let msg = {id:item.dId,type:item.clazz}
                this.$router.push(path+item.dId ,msg)
            }
        },
        gotoUrl(item) {
            if(item.hasOwnProperty('url')) {
                window.open(item.url);
            } 
        },
         geDetail(path,item) {
            if(item.hasOwnProperty('url')) {
                window.open(item.url);
            } else {
                let msg = {id:item.dId,type:item.clazz}
                this.$router.push(path+item.dId ,msg)
            }
        },
        
    },
    mounted() {
        this.getNewsNoticeList();
        this.getNewsCompanyList();
        this.getNewsOutlineList();
        this.getNewsTeachingList();
        this.getNewsTrainList();
        this.getNewsTestList();
        this.getTeaList()
        this.getCCPTList()
            
    },
    beforeDestroy() {
}
}
</script>

<style lang="less">
    @import "./less/home.less";
</style>